export const UPDATED_MOVEMENTS_TO_DECLARE = 'updated_movements_to_declare';
export const BANK_ACCOUNT_BALANCES_MUST_CHECK = 'bank_account_balances_must_check';
export const DETAILED_TEMPORARY_ACCOUNT_MUST_BE_CLEARED = 'detailed_temporary_account_must_be_cleared';
export const INTERNAL_TRANSFER_ACCOUNT_MUST_BE_CLEARED = 'internal_transfer_account_must_be_cleared';
export const VAT_ACCOUNTS_NOT_SET = 'vat_accounts_not_set';
export const VAT_ENCASEMENT_IS_DEFINED_ON_ACCOUNTING_ENTRIES_IN_ENCASEMENT =
  'vat_encasement_is_defined_on_accounting_entries_in_encasement';
export const ALL_BANK_PCG_ENTRIES_MUST_HAVE_MOVEMENTS = 'all_bank_pcg_entries_must_have_movements';
export const CLIENT_SUPPLIER_ACCOUNTS_MUST_BE_CLEARED = 'client_supplier_accounts_must_be_cleared';
export const CREDIT_NOT_ON_SALES_ACCOUNT = 'credit_not_on_sales_account';
export const LEASING_RENT_VARIATION_MUST_BE_STABLE = 'leasing_rent_variation_must_be_stable';
export const MULTIPLE_VAT_RATES_ON_SAME_ACCOUNT = 'multiple_vat_rates_on_same_account';
export const VAT_DECLARATION_DAY_MUST_BE_CHECKED = 'vat_declaration_day_must_be_checked';

export const VAT_DECLARATION_CONSISTENCY_CHECK_CODES_WITH_DETAILS = [
  UPDATED_MOVEMENTS_TO_DECLARE,
  BANK_ACCOUNT_BALANCES_MUST_CHECK,
  DETAILED_TEMPORARY_ACCOUNT_MUST_BE_CLEARED,
  INTERNAL_TRANSFER_ACCOUNT_MUST_BE_CLEARED,
  VAT_ACCOUNTS_NOT_SET,
  VAT_ENCASEMENT_IS_DEFINED_ON_ACCOUNTING_ENTRIES_IN_ENCASEMENT,
  ALL_BANK_PCG_ENTRIES_MUST_HAVE_MOVEMENTS,
  CLIENT_SUPPLIER_ACCOUNTS_MUST_BE_CLEARED,
  CREDIT_NOT_ON_SALES_ACCOUNT,
  LEASING_RENT_VARIATION_MUST_BE_STABLE,
  MULTIPLE_VAT_RATES_ON_SAME_ACCOUNT
] as const;

export type VatDeclarationConsistencyCheckCodesWithDetails =
  (typeof VAT_DECLARATION_CONSISTENCY_CHECK_CODES_WITH_DETAILS)[number];
